import type { Component } from 'solid-js'
import { shareBroadcast } from '~/lib/share'

type Props = {
  /** いま放送中の番組名。無ければサイトの紹介だけを載せる */
  title?: string
  /** ラベルを出さずアイコンだけにする（全画面の帯など、幅が無いとき） */
  iconOnly?: boolean
  class?: string
}

/**
 * いま見ている放送を SNS へ持っていくボタン（要件定義 17 章）。
 *
 * 共有シートが使えない環境では X の投稿画面を開く。
 * 文面は src/lib/share.ts が組み立てる（非公式である表記を必ず含める。要件定義 14 章）。
 */
export const ShareButton: Component<Props> = (props) => (
  <button
    type="button"
    onClick={() => void shareBroadcast(props.title)}
    title="いま流れている番組をシェアする"
    aria-label="いま流れている番組をシェアする"
    class={`inline-flex shrink-0 items-center gap-1.5 text-ch-muted transition-colors hover:text-ch-text ${props.class ?? ''}`}
  >
    <svg
      viewBox="0 0 16 16"
      class="size-3.5 shrink-0"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="3.5" r="2" />
      <circle cx="4" cy="8" r="2" />
      <circle cx="12" cy="12.5" r="2" />
      <path d="M5.8 7 10.2 4.5" />
      <path d="M5.8 9l4.4 2.5" />
    </svg>
    {!props.iconOnly && <span class="text-[11px] font-semibold">シェア</span>}
  </button>
)
